export const ParentQRId = {
    
    PUT_PARENTQRID: "PUT_PARENTQRID",
}